import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cxpu3vwkk5: FaireBrandEntity = {
  token: "b_cxpu3vwkk5",
  type: "brand",
  name: "Magic Manes",
  avatarUrl:
    "https://cdn.faire.com/fastly/adaf1c6fa65afb7719d1030dd8d8b2a720c31b614a83027dc314e10981363f86.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d08d719b005c9acd95dd797efa5ed7ba3632a4351edee9a47f9271193ab7fd07.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/adaf1c6fa65afb7719d1030dd8d8b2a720c31b614a83027dc314e10981363f86.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d08d719b005c9acd95dd797efa5ed7ba3632a4351edee9a47f9271193ab7fd07.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 69,
  rating: 4.9,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Magic Manes is a family owned and operated company based in sunny, wonderful, magical San Diego, California. Our family spends our leisure time dreaming of new and innovative hair accessories for kids and teens. We are inspired by rainbows, donuts, unicorns, magic, ice cream cones and cupcakes! We also watch Netflix, play Fortnite, have hilarious family game nights, do cookie art and take midnight swims.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.122Z",
    importedBy: "entity-db-cli",
  },
};
